<template>
  <mdb-select
    search
    @getValue="getSelectValue"
    v-model="List"
    :label="Label"
    :placeholder="Placeholder"
    :visibleOptions="5"
  />
</template>

<script>
import { mdbSelect } from "mdbvue";

export default {
  name: "ListSelection",
  components: {
    mdbSelect,
  },
  props: {
    List: Array,
    Label: String,
    Placeholder: String,
  },

  methods: {
    getSelectValue(val) {
      this.$emit("selection", val);
    },
  },
};
</script>
